"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user = exports.initialState = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _immer = _interopRequireDefault(require("immer"));
var _actions = require("../block-party/containers/Login/actions");
var _constants = require("./constants");
var _handlers = require("./handlers");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var user = {
  isLoggedIn: false,
  id: 0,
  agentId: 0,
  hashId: "",
  sessionId: null,
  businessContext: [],
  name: "",
  email: "",
  enableEmailUpdate: true,
  maskedEmail: "",
  maskedPhone: "",
  jwt: {
    app: "",
    firebase: "",
    cognito: ""
  },
  phone: {
    countryCode: "",
    areaCode: "",
    phoneNumber: ""
  },
  country: "BR",
  channel: "",
  isPhoneRegistered: false,
  acceptWhatsapp: true,
  hasDocument: false,
  isPartner: false,
  loginProvider: null,
  identities: []
};
exports.user = user;
var initialState = {
  response: {
    status: undefined,
    type: undefined
  },
  user: user,
  accountForm: {},
  redirectUrl: "",
  isRequestOngoing: false,
  request: {
    sendAccessCodeStatus: _constants.REQUEST_STATUS.UNSET,
    pinCodeValidationStatus: _constants.REQUEST_STATUS.UNSET,
    submitAccountStatus: _constants.REQUEST_STATUS.UNSET
  },
  query: ""
};
exports.initialState = initialState;
function loginReducer(draft, action) {
  switch (action.type) {
    case _constants.LOGIN_SUCCESS:
      return (0, _handlers.handleLoginSucceeded)(draft, action);
    case _constants.SOCIAL_LOGIN_SUCCESS:
      return (0, _handlers.handleSocialLoginSucceeded)(draft, action);
    case _constants.UPDATE_USER_CHANNEL:
      draft.user = _objectSpread(_objectSpread({}, draft.user), {}, {
        channel: action.channel
      });
      return draft;
    case _constants.SET_FIRST_VISIT:
      draft.user = _objectSpread(_objectSpread({}, draft.user), {}, {
        firstVisit: action.value
      });
      return draft;
    case _constants.SEND_ACCESS_CODE:
      return (0, _handlers.handleSendAccessCode)(draft, action);
    case _constants.SOCIAL_LOGIN_SEND_ACCESS_CODE:
      return (0, _handlers.handleSendAccessCode)(draft, action);
    case _constants.VALIDATE_PHONE_ACCESS_CODE:
    case _constants.SOCIAL_VALIDATE_PHONE_ACCESS_CODE:
    case _constants.VALIDATE_PHONE_OWNERSHIP:
    case _constants.SOCIAL_VALIDATE_AND_CREATE_ACCOUNT:
      return (0, _handlers.handleValidatePhone)(draft, action);
    case _constants.VALIDATE_EMAIL_PIN:
    case _constants.VALIDATE_EMAIL_OWNERSHIP:
      return (0, _handlers.handleValidateEmail)(draft, action);
    case _constants.VALIDATE_EMAIL_MASK:
      return (0, _handlers.handleValidateEmailMask)(draft, action);
    case _constants.SUBMIT_ACCOUNT_FORM:
    case _constants.SOCIAL_SUBMIT_ACCOUNT_FORM:
      return (0, _handlers.handleSubmitAccountForm)(draft, action);
    case _constants.LOGIN_SOCIAL_CREDENTIAL_MATCHED:
      return (0, _handlers.handleLoginSocialCredentialMatched)(draft, action);
    case _constants.LOGIN_SOCIAL_PHONE_MATCHED:
      return (0, _handlers.handleLoginSocialPhoneMatched)(draft, action);
    case _constants.BEGIN_ACCOUNT_OWNERSHIP:
    case _constants.BEGIN_SOCIAL_EMAIL_CONFIRMATION:
      return (0, _handlers.handleAccountOwnershipSendCodeConfirmation)(draft, action);
    case _constants.UPDATE_USER:
      return (0, _handlers.handleUpdateUser)(draft, action);
    case _constants.UPDATE_USER_ATTRIBUTE:
      return (0, _handlers.handleUpdateUserAttribute)(draft, action);
    case _constants.UPDATE_USER_PHONE:
      return (0, _handlers.handleUpdateUserPhone)(draft, action);
    case _constants.UPDATE_USER_WITH_SOCIAL_USER_DATA:
      return (0, _handlers.handleUpdateUserWithSocialUserData)(draft, action);
    case _constants.REFRESH_PROFILE:
    case _actions.REFRESH_PROFILE:
      return (0, _handlers.handleRefreshProfile)(draft, action);
    case _constants.SET_RESPONSE:
      draft.response = _objectSpread(_objectSpread({}, draft.response), action.response);
      return draft;
    case _constants.CLEAR_RESPONSE:
      draft.response = {
        status: undefined,
        type: undefined
      };
      return draft;
    case _constants.CLEAR_REQUEST_STATUS:
      draft.isRequestOngoing = false;
      draft.request = initialState.request;
      return draft;
    case _constants.SAVE_REDIRECT_URL:
      return (0, _handlers.handleSaveRedirectUrl)(draft, action);
    case _constants.SAVE_QUERY:
      return (0, _handlers.handleSaveQuery)(draft, action);
    case _constants.LOGIN_OPTION_SELECTED:
      return (0, _handlers.handleSaveLoginProvider)(draft, action);
    case _constants.CLEAR_USER:
      draft.user = user;
      return draft;
    case _constants.LOGOUT:
    case _constants.LOGOUT_WITHOUT_REDIRECT:
    case _actions.LOGOUT:
      return initialState;
    default:
      return draft;
  }
}
var _default = (0, _immer.default)(loginReducer, initialState);
exports.default = _default;